var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3207 0L5.95159 4.79976V18.7997C5.11649 18.3414 3.95492 18.2625 2.81725 18.6762C1.00089 19.3376 -0.059826 21.0047 0.448495 22.4C0.956506 23.796 2.84115 24.3912 4.65566 23.7302C6.30692 23.13 7.15163 21.7176 7.15163 20.3999C7.15629 17.9739 7.15629 10.1225 7.15163 8.08602L14.5338 6.15692V16.7996C13.6987 16.3412 12.5368 16.263 11.3994 16.6767C9.58526 17.3377 8.52424 19.0049 9.03318 20.4005C9.53716 21.7958 11.4233 22.3913 13.2378 21.7303C14.8891 21.1301 15.7338 19.718 15.7338 18.4C15.7388 15.8626 15.7388 7.389 15.7388 5.84348L23.1209 3.91374V13.9999C22.2858 13.5416 21.1193 13.4627 19.982 13.8764C18.1674 14.5381 17.107 16.2049 17.6157 17.6006C18.1246 18.9965 20.0062 19.5914 21.8253 18.9304C23.4716 18.3305 24.3163 16.9178 24.3213 15.6004C24.3213 13.2846 24.3213 0 24.3213 0H24.3207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.75ec0a143f9c0b0f83a8afb94a99c9d0.svg";
export { ForwardRef as ReactComponent };